import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content", "loading"]
  static values  = { previewUrl: String }

  async openModal(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
    this.loadingTarget.classList.remove("hidden")
    if (this.hasContentTarget) this.contentTarget.classList.add("hidden")

    try {
      const resp = await fetch(this.previewUrlValue, {
        headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "text/html" }
      })
      const html = await resp.text()
      this.contentTarget.innerHTML = html
      this.loadingTarget.classList.add("hidden")
      this.contentTarget.classList.remove("hidden")
    } catch {
      this.loadingTarget.classList.add("hidden")
      this.contentTarget.innerHTML = "<p class='text-tavern-danger p-4 text-sm'>Could not reach D&D Beyond. Check your connection and try again.</p>"
      this.contentTarget.classList.remove("hidden")
    }
  }

  close() {
    this.dialogTarget.close()
  }

  onSubmitEnd(event) {
    if (event.detail.success) {
      this.dialogTarget.close()
    }
  }
}
